export const HELLO_AT_MARBLE_EMAIL = "hello@marblehealth.com";
export const SCHOOLS_AT_MARBLE_EMAIL = "schools@marblehealth.com";
export const PROVIDERS_AT_MARBLE_EMAIL = "providers@marblehealth.com";
export const JAKE_AT_MARBLE_EMAIL = "jake@marblehealth.com";
export const MARBLE_TEAM_NAME = "Marble Team";

export const STATE_CREDENTIALING_EMAILS: Partial<Record<string, string>> = {
  AZ: "az.cred@marblehealth.com",
  NJ: "nj.cred@marblehealth.com",
  NY: "cred@marblehealth.com",
  OH: "oh.cred@marblehealth.com",
};

export const DEFAULT_CREDENTIALING_EMAIL = "cred@marblehealth.com";

// TODO: This should be defined using Email templates
export const MARBLE_EMAIL_FOOTER =
  '<div><span style="font-weight:600;font-size:12px;color:#000;">Marble Health</span> | <a href="www.marblehealth.com">marblehealth.com</a><div>';

// Temporary hack to disable emails to specific email addresses.
// In the future we'll add a flexible user preferences system to handle this.
export const DISABLE_EMAILS_TO = [
  "elizabeth.bradford@democracyprep.org",
  "ashalexemail@gmail.com",
  "everclearsewer@gmail.com",
  "scohen@chnnyc.org",
  "ADoctor@schools.nyc.gov",
  "caitlin.dangelo@lodi.k12.nj.us",
];
